import React from 'react';
import { CgChevronDown, CgChevronLeft } from 'react-icons/cg';

const menuData = [
    {
        title: 'Acasă',
        path: '/',
    },

    {
        title: 'Despre Noi',
        path: '/despre-noi',
    },

    {
        title: 'Servicii',
        path: '/servicii',
    },

    {
        title: 'Contact',
        path: '/contact',
    },
];

export default menuData;
